import React from 'react';
import adminApi, { setAdminToken } from '../api/adminClient';
import withRouter from '../withRouter';

class AdminLoginPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = { email: '', password: '', error: null, submitting: false };
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const { email, password } = this.state;
    this.setState({ submitting: true, error: null });

    adminApi.login(email, password)
      .then(({ token }) => {
        setAdminToken(token);
        this.props.navigate('/admin/dashboard');
      })
      .catch((err) => {
        this.setState({
          submitting: false,
          error: err.response?.data?.error || 'Login failed'
        });
      });
  };

  render() {
    const { email, password, error, submitting } = this.state;
    return (
      <div className="admin-login-page">
        <h1>Admin sign in</h1>
        <form onSubmit={this.handleSubmit}>
          <label>
            Email
            <input type="email" required value={email} onChange={(e) => this.setState({ email: e.target.value })} />
          </label>
          <label>
            Password
            <input type="password" required value={password} onChange={(e) => this.setState({ password: e.target.value })} />
          </label>
          {error && <p className="error">{error}</p>}
          <button className="btn btn-primary" type="submit" disabled={submitting}>
            {submitting ? 'Signing in...' : 'Sign in'}
          </button>
        </form>
      </div>
    );
  }
}

export default withRouter(AdminLoginPage);
